module.exports = __webpack_public_path__ + "static/media/building.70072438.svg";